import { ApiResponse, TokenData, Designation } from '../models';
import * as http from './http';
import ApiService from './service';

export class DesignationService extends ApiService {
  public async loadAllDesignation() {
    const url = `${this.apiDomain}/api/designation`;

    const resposne = await http.get<ApiResponse<Designation[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateDesignation(data: Designation, id?: string) {
    const url = `${this.apiDomain}/api/designation/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createDesignation(data: Designation) {
    const url = `${this.apiDomain}/api/designation`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteDesignation(id?: string) {
    const url = `${this.apiDomain}/api/designation/${id}`;

    const response = await http.remove<ApiResponse<Designation>>(
      url,
      this.store
    );
    return response.data;
  }
}
